var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "size-4",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.875 7.48096C9.875 7.97824 9.67746 8.45515 9.32583 8.80678C8.97419 9.15841 8.49728 9.35596 8 9.35596C7.50272 9.35596 7.02581 9.15841 6.67417 8.80678C6.32254 8.45515 6.125 7.97824 6.125 7.48096C6.125 6.98368 6.32254 6.50676 6.67417 6.15513C7.02581 5.8035 7.50272 5.60596 8 5.60596C8.49728 5.60596 8.97419 5.8035 9.32583 6.15513C9.67746 6.50676 9.875 6.98368 9.875 7.48096Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6875 7.48096C12.6875 11.9447 8 14.5122 8 14.5122C8 14.5122 3.3125 11.9447 3.3125 7.48096C3.3125 6.23775 3.80636 5.04547 4.68544 4.16639C5.56451 3.28732 6.7568 2.79346 8 2.79346C9.2432 2.79346 10.4355 3.28732 11.3146 4.16639C12.1936 5.04547 12.6875 6.23775 12.6875 7.48096Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPin;